<template>
  <div class="my-item z-info">
    <div class="news-change" style="margin-bottom:20px;">
        <RadioGroup v-model="newsAudit" type="button" @on-change="init">
          <Radio label="1">布展车证</Radio>
          <Radio label="2">撤展车证</Radio>
        </RadioGroup>
      </div>
    <template>
      <div style="min-height: 400px;" v-if="CarList.length">
        <Row :gutter="30">
          <Col :md="12" :xl="8" :xxl="6" class="w-20">
          <!--<div class="addPro pro"  @click="addCar">-->
          <!--    <i class="icon iconfont icon-jia3"></i>-->
          <!--    <span>添加车证</span>-->
          <!--</div>-->
          </Col>
          <Col :md="12" :xl="8" :xxl="6" v-for="(item, index) in CarList" :key="'releaseInt-' + index" class="w-20">
          <div class="pro">
            <div class="pro-top">
              <div class="pro-top-l">
                <h3>联系人：{{item.contactName}}</h3>
                <p>联系电话：{{item.contactPhone}}</p>
                <p class="name">公司名称：{{item.companyName}}</p>
              </div>
              <div class="pro-top-r">
                <h4>{{item.number}}</h4>
                <p>车辆吨位：{{item.tonnage ? item.tonnage + '吨' : item.tonnage}}</p>
              </div>
              <!-- <div class="state-Type">
                    <span v-if="item.commandId == 1" style="color:#1890ff;">状态：新增</span>
                    <span v-if="item.commandId == 2" style="color:#fe781d;">状态：修改</span>
                    <span v-if="item.commandId == 3" style="color:#009944;">状态：删除</span>
                </div> -->
            </div>
            <div class="pro-tool">
              <div class="pro-tool-item" @click="editModal(item)" style="color:#1890ff">编辑</div>
              <div class="pro-tool-line"></div>
              <div class="pro-tool-item z-del">
                <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItem(item)" style="color:#ff0000">删除</Poptip>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <div class="my-page">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </template>
    <editCar :show="carShow" @close="closeModal" :ModalTitle="ModalTitle" :options="options"></editCar>
    <!-- <emptyList v-if="!CarList.length"></emptyList> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import emptyList from "@components/emptyList/emptyList";

import editCar from "./editCar.vue";
export default {
  name: "exhibition-car-no",
  props: ["addShow", "searchField"],
  data() {
    return {
      deleted: false,
      edit: false,
      list: null,
      editInfo: null,
      delInfo: null,
      newsAudit: '1',
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      timer: null,
      carShow: false,
      ModalTitle: "", // 弹框标题
      CarList: [],
      options: {},
      CompanyName: "",
      contactName: "",
    };
  },
  watch: {
    searchField(val) {
      this.pageIndex = 1;
    },
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition",
    }),
    header() {
      return this.$store.state.header;
    },
    joinInfo() {
      return JSON.parse(localStorage.getItem("vuex")).loginModule.joinInfo;
    },
    option() {
      return {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        type: this.newsAudit == '2' ? 'Dismantling' : 'ExhibitionArrange',
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 1,
            Predicates: [],
          },
        },
      };
    },
  },
  components: {
    editCar,
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCaritem: "hostSetModule/getCaritem",
    }),
    closeModal() {
      this.carShow = false;
      this.init();
    },

    editModal(item) {
      this.carShow = true;
      this.ModalTitle = "编辑车证";
      this.options = {
        msg: item,
        model: "edit",
      };
    },
    delItem(item) {
      this.$http
        .delete(`/api/Vehicle/DeleteForce?id=${item.id}`, this.header)
        .then((res) => {
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("删除成功！");
            this.init();
          } else {
            this.$Message.error("删除失败，请重新尝试");
          }
        });
    },
    init() {
      this.$emit('changeAudit',this.newsAudit)
      if (this.searchField) {
        this.option.Wheres.wheres.Predicates.push(
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "contactName",
              Value: `%${this.searchField}%`,
            },
          },
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "companyName",
              Value: `%${this.searchField}%`,
            },
          }
        );
      }
      this.getCarList(this.option);
    },
    async getCarList(opt) {
      // 获取车证列表
      let data = await this.getCaritem(opt);
      this.CarList = data.items;
      this.totalCount = data.totalCount;
      this.option.Wheres.wheres.Predicates = [];
    },
    changePage(e) {
      this.pageIndex = e;

      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.my-item .pro-top-l .name{
    min-height: 48px;
  }
.my-item {
  min-width: 600px;
  padding: 24px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .addPro {
    padding: 40px;
    .icon {
      font-size: 60px;
      text-align: center;
      display: block;
      color: #999;
    }
    span {
      display: block;
      font-size: 18px;
      color: #999;
      text-align: center;
      position: relative;
      top: -5px;
    }
  }
  .pro {
    margin-bottom: 20px;
    position: relative;

    background-color: #fafafa;
    box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
    &-top {
      width: 100%;
      background: #fff;
      padding: 20px;
      display: flex;
      position: relative;
      &-l {
        width: 65%;
        h3 {
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          color: #333;
          padding-bottom: 10px;
        }
        p {
          font-size: 14px;
          line-height: 16px;
          padding: 8px 0;
          color: #333;
        }
      }
      &-r {
        width: 40%;
        text-align: right;
        h4 {
          font-size: 18px;
          line-height: 32px;
          color: #333;
          width: 100%;
          border-radius: 5px;
          background-color: #d3e7ff;
          font-weight: 400;
          text-align: center;
        }
        p {
          font-size: 14px;
          line-height: 16px;
          padding: 8px 0;
          color: #333;
          text-align: left;
        }
      }
      .state-Type {
        position: absolute;
        right: 20px;
        bottom: 20px;
      }
    }

    &-tool {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      &-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
    text-align: center;
    padding-top: 50px;
  }
}
</style>
